"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mappingQueryComposer = exports["default"] = void 0;

var actions = _interopRequireWildcard(require("../actions/campaignCreator"));

var _actions = require("../actions");

var _reselect = require("reselect");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var initialState = {
  isFetching: false,
  insightIds: [],
  insightSetGroupId: 3,
  insightSetId: 110,
  error: null
};

var mapping = function mapping(state, action) {
  if (state === void 0) {
    state = initialState;
  }

  switch (action.type) {
    case actions.GET_PERSONA_INSIGHTS_REQUEST:
    case actions.GET_COMMUNITY_INSIGHTS_REQUEST:
      return _extends({}, state, {
        isFetching: true,
        error: null
      });

    case actions.GET_PERSONA_INSIGHTS_FAILURE:
    case actions.GET_COMMUNITY_INSIGHTS_FAILURE:
      return _extends({}, state, {
        isFetching: false,
        error: action.payload
      });

    case actions.GET_PERSONA_INSIGHTS_SUCCESS:
    case actions.GET_COMMUNITY_INSIGHTS_SUCCESS:
      return _extends({}, state, {
        isFetching: false
      }, action.payload);

    case _actions.SET_AUDIENCE_VIEW:
    case _actions.RESET_PAGE_DATA:
    case _actions.RESET_SELECTED_PERSONAS:
      return initialState;

    default:
      return state;
  }
};

var _default = mapping;
exports["default"] = _default;
var mappingQueryComposer = (0, _reselect.createSelector)(function (state) {
  return state.mapping;
}, function (insightData) {
  var _insightData$insightI = insightData.insightIds,
      insightIds = _insightData$insightI === void 0 ? [] : _insightData$insightI,
      _insightData$insightS = insightData.insightSetGroupId,
      insightSetGroupId = _insightData$insightS === void 0 ? null : _insightData$insightS,
      _insightData$insightS2 = insightData.insightSetId,
      insightSetId = _insightData$insightS2 === void 0 ? null : _insightData$insightS2,
      isFetching = insightData.isFetching;
  insightIds = insightIds.map(function (insight) {
    return insight.id;
  }).join(',');
  var mappingQueryString = "&insightgroupid=" + (insightSetGroupId ? insightSetGroupId : '') + "&insightsetid=" + (insightSetId ? insightSetId : '') + (insightIds.length ? "&insightid=" + insightIds : '') + "&insightsetmode=2";
  return [mappingQueryString, isFetching];
});
exports.mappingQueryComposer = mappingQueryComposer;